"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const errorNotification_1 = require("./errorNotification");
const handleError = (error, setErrors = (errors) => { }) => {
    if (axios_1.default.isAxiosError(error)) {
        if (error.response && error.response.status) {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            if (error.response.data.message) {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
        }
    }
    else {
        (0, errorNotification_1.notifyError)(error);
    }
};
exports.default = handleError;
